module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daymodrain-3528d380f5b23c01b7d0a265e4085bca.png";